import { CroppingGroupVm } from "./croppingGroup"
import { ClosedPeriodProvider } from "./nvz/closedPeriodProvider"
import { FieldViewModel, Geometry2, ICrop, ICropping, IFertiliserProduct, IField, INMaxCropGroup, INtrNutrients, INtrReqNutrients, IOmniaService, IOmniaSettings, ISoilAnalysis, models, PlanValidationService, SharedFieldsService } from "./omnia"
import { BalanceProvider } from "./services/balance"
import { INutritionCalcService } from "./services/calcService"
export type { INutrientAppLayer, INutrientAppLayerData, INutrientAppZone } from "./omnia"

import { ISoilTypeService, IDataLayer, IDataLayerZone, IDataLayerType, IFertiliserStock, IManureStock, IManureType, IFertiliserAnalysis } from "./omnia"
import { BiomassUnit, FertiliserAppUnit, LayerTypeId, ManureAppMethod, NitrogenSnsMethod, NutrientGroup, NutrientType, ProductAppInput, NtrReqConfigMode as ReqConfigMode, SatImageType } from "@omnia/shared/generated/enums"
export type { ISoilTypeService, IDataLayer, IDataLayerZone, IDataLayerType, IFertiliserStock, IManureStock, IManureType, IFertiliserAnalysis }

export type IFieldsService = SharedFieldsService
import { SoilUnit } from "@omnia/shared/soil"

import { ResourceMetadata } from "@omnia/shared/resources/types"

export {
    NutrientType,
    ReqConfigMode,
    FertiliserAppUnit,
    NutrientGroup,
    LayerTypeId,
    ProductAppInput,
    ManureAppMethod,
    SoilUnit
}

export type {
    INtrNutrients,
    ISoilAnalysis,
}

export type CroppingProvider = (croppingId: number) => FieldViewModel

export interface INutritionProductApp {

    readonly referenceDate: Date
    isLiquid(): boolean
    isManure(): boolean
    isLime(): boolean

}

export interface IClosedPeriod {
    StartDate?: Date;
    EndDate?: Date;
    MaxRate?: number;
    MaxRateToMarch?: number;
    Expemption: boolean;
    SpecificStartDate?: Date;
}

export interface IClosedPeriodManureItem {
    LightAndShallow: boolean;
    CropGroup: NVZCropGroup;
    MaxSowingDate?: Date;
    ClosedPeriod: IClosedPeriod;
}

export enum NVZCropGroup {
    Other = 1,
    Grass = 2,
    WinterCereals = 3,
    WinterOsrAndCovers = 4
}

export interface IClosedPeriodManure {
    ManureTypeId: number;
    ClosedPeriodManureItems: IClosedPeriodManureItem[];
}

export interface IClosedPeriodFertiliserItem {
    CropId: number;
    Grass: boolean;
    ClosedPeriod: IClosedPeriod;
}

export interface IClosedPeriodFertiliser {
    City: string;
    ClosedPeriodFertiliserItems: IClosedPeriodFertiliserItem[];
}

export interface IClosedPeriodResult {
    closed: boolean;
    expemption?: boolean;
    maxRate?: number;
    maxRateToMarch?: number;
    startDate?: Date;
    endDate?: Date;
    specificStartDate?: Date;
}

export interface IFieldLimitResult {
    yearCount: number;
    maxRate: number;
}

export interface INutrientGroup {
    key: string;
    name: string;
    nutrients: INutrient[];
}

export interface INutrient {
    key: string,
    name: string,
    nutrient: NutrientType,
    tonnesPerHa: boolean
}

export interface INtrReqConfig {

    NtrReqConfigId: number;
    CroppingId: number;

    SoilAnalysisLayerId?: number;
    SoilTypeLayerId?: number;
    SubsoilTypeLayerId?: number;
    TargetYieldLayerId?: number;

    NConfigMode: ReqConfigMode;
    NRounding: number;
    NMergeZones: boolean;

    NBreakeven?: {
        Enabled: boolean
        NAdjustment?: number
        GrainPrice?: number
        NPrice?: number
    }

    PkConfigMode: ReqConfigMode;
    PkRounding: number;
    PkMergeZones: boolean;
    CropOfftake: boolean;

    P2O5CutOff?: number
    K2OCutOff?: number
    MgOCutOff?: number

    LimeConfigMode: ReqConfigMode;
    LimeMergeZones: boolean;

    TerraMap?: boolean

    CreatedOn?: Date;
    UpdatedOn?: Date;

}


export type NBreakevenConfig = INtrReqConfig["NBreakeven"]

export interface INtrZone {

    CroppingId: number;
    Cropping: FieldViewModel;

    PlanId?: number;

    Area: number;
    Geometry: Geometry2
    Zone: boolean;
    ZoneNumber: number;

    Aggregate: boolean;

}

export interface INtrReq extends INtrReqNutrients, INtrZone {

    NtrReqId: number;
    ConfigId: number;

    NutrientGroup: NutrientGroup;
    Nutrient?: NutrientType

    CalculationDate?: Date;
    CreatedOn?: Date;
    UpdatedOn?: Date;

    CropId?: number

    SoilAnalysisId?: number;
    SoilAnalysisLayerId?: number;

    TargetYield?: number;
    TargetYieldLayerId?: number;

    SoilTypeLayerId?: number;
    SubsoilTypeLayerId?: number;

    NZoneNumber?: number;
    NCalcStatus?: number;
    NCalcStatusText?: string;

    PkZoneNumber?: number;
    PkCalcStatus?: number;
    PkCalcStatusText?: string;

    /**
     * If true, indicates that PK requirements where calculated using the default (ADAS) model
     * rather than the requested (currently only SRUC) one
     */
    PkDefaultModel?: boolean

    CalcRequiredN?: number;
    CalcRequiredSO3: number;
    CalcRequiredP2O5?: number;
    CalcRequiredK2O?: number;
    CalcRequiredMgO?: number;

    OpeningBalanceN?: number;
    OpeningBalanceP2O5?: number;
    OpeningBalanceK2O?: number;
    OpeningBalanceMgO: number;

    PkAnalysisP2O5?: number;
    PkAnalysisK2O?: number;
    PkAnalysisMgO?: number;
    SoilAnalysispH?: number;
    SoilAnalysisNew?: boolean;

    NMax?: number;

    Sns?: number;
    SnsMethod?: NitrogenSnsMethod;

    LimeZoneNumber?: number;
    LimeCalcStatus?: number;
    LimeCalcStatusText?: string;

    LimeCropTargetpH?: number;
    LimeCropTargetpHDefault?: number;

    Comments: string;

    HasError?: boolean
    ErrorText?: string

}

export interface INtrBalance extends INtrZone, INtrNutrients {

    NtrBalanceId: number;

    NutrientGroup: NutrientGroup;

    CroppingId: number;
    InitN?: number;
    InitP2O5?: number;
    InitK2O?: number;
    InitMgO?: number;

    SoilAnalysisNew?: boolean;

    CalcN: number;
    CalcP2O5: number;
    CalcK2O: number;
    CalcMgO: number;

    P2O5SoilIndex: number;
    K2OSoilIndex: number;

}

export interface INtrApp extends INtrNutrients, INtrZone {

    NtrAppId: number;

    // PlanId == NutritionPlanId
    PlanId: number;
    Plan: INutritionPlan;

    // AppId == NutritionPlanProductAppId
    AppId: number;
    App: INutritionPlanProductApp;

    CroppingId: number;
    Cropping: FieldViewModel;

    ApplicationDate: Date;
    ProductRate?: number;
    ProductAmount?: number;

    UserDefined?: boolean;
    InitProductRate?: number;

    Manure?: boolean;
    ManureTypeId?: number;

    NAvailable?: number;
    NTotal?: number;

    P2O5Available?: number;
    K2OAvailable?: number;

    NAnalysis?: number;
    SO3Analaysis?: number;
    P2O5Analysis?: number,
    K2OAnalysis?: number,
    MgOAnalysis?: number,
    NeutralisingValue?: number;

}

export interface ManureNApp {

    CroppingId: number

    PlanId: number
    AppId: number
    ApplicationDate: Date

    /** Total N, in kg/ha */
    NTotal: number

    /** Available N, in kg/ha */
    N: number

}

export interface IRequirementsProvider {

    getInitialRequirements(croppingId: number, zones?: boolean): INtrReq[];
    getCroppingInitialRequirements(croppingId: number): INtrReq;

    getPlanRequirements(croppingId: number, planId: number): INtrReq[];
    getPlanClosingRequirements(croppingId: number, planId: number): INtrReq[];

    getClosingRequirements(croppingId: number, zones?: boolean): INtrReq[];
    getCroppingClosingRequirements(croppingId: number): INtrReq;

    /**
     * Returns all requirement zones, both opening and closing, and grouped by cropping
     * For each cropping, the "plans" array always starts with the opening requirements (before any application),
     * then lists all plans in application order
     */
    getOrderedRequirementZones(): { croppingId: number, plans: { planId: number, zones: INtrReq[] }[] }[];

    getRequirements(croppingId: number): INtrReq[];

}

export interface IPlanTemplateService {

    getTemplates(): ng.IPromise<INutritionTemplate[]>;
    saveTemplate(nutritionTemplate: INutritionTemplate): ng.IPromise<any>;
    deleteTemplate(nutritionPlanTemplateId: number): ng.IPromise<any>;

}

export interface INutritionService extends IOmniaService {

    readonly settings: IOmniaSettings;

    readonly fields: FieldViewModel[];
    readonly cropping: FieldViewModel[];

    readonly manureAnalysis: ManureAnalysisProvider
    readonly closedPeriodService: ClosedPeriodProvider
    readonly soilTypeService: ISoilTypeService
    readonly calculationService: INutritionCalcService

    readonly planValidationService: PlanValidationService

    readonly balance: BalanceProvider

    planFilter: string

    getFertiliserStocks(): IFertiliserStock[];
    getFertiliserProducts(): IFertiliserProduct[];
    getManureStocks(): IManureStock[];

    getConfig(): INtrReqConfig[];

    getPlans(accessible?: boolean): INutritionPlan[];

    getRequirements(): INtrReq[];
    getRequirementsProvider(): IRequirementsProvider;

    getApplications(accessible?: boolean): INtrApp[];
    getManureApplications(filter: (app: ManureNApp) => boolean): ManureNApp[]

    getNMaxCropGroups(): INMaxCropGroup[];
    getNMaxCroppingGroup(croppingId: number): INMaxCropGroup;

    getNutritionLayers(): ng.IPromise<IDataLayer[]>;
    getBiomassLayers(): ng.IPromise<ICroppingBiomass[]>;
    getDataLayerType(typeId: LayerTypeId): IDataLayerType;

    getSoilAnalysisUsedForRequirements(): ng.IPromise<ISoilAnalysis[]>;

    getNotifications(): Notifications

    getExclusiveAccess(): ng.IPromise<boolean>
    releaseExclusiveAccess(): ng.IPromise<any>

    calculateRequirements(config: INtrReqConfig[]): ng.IPromise<any>
    updateRequirements(updates: ICroppingReqUpdateModel[]): ng.IPromise<INtrReq[]>;
    resetRequirements(croppingIds: number[], requirements: boolean, balances: boolean): ng.IPromise<any>;

    savePlan(plan: IPlanUpdateModel): ng.IPromise<any>;
    deletePlan(planId: number): ng.IPromise<any>;
    calculateCroppingPlans(croppingIds: number[], recalculateAll: boolean): ng.IPromise<any>;

    updateApplicationZones(zones: IAppZoneUpdateModel[]): ng.IPromise<any>;

    isCroppingInNutritionPlans(croppingId: number): boolean;

    getSoilUnit(): SoilUnit

}

export type ManureAnalysisProvider = (stock: IManureStock, application?: INutritionPlanProductApp, cropping?: ICropping) => IFertiliserAnalysis

export interface ICroppingBiomass {

    FieldId: number;
    CroppingId: number;

    CroppingArea: number;

    Name?: string;

    BiomassDate: Date;
    Unit?: BiomassUnit;

    LayerId: number;
    LayerName: string;
    LayerDate: Date;

    SourceImageType?: SatImageType,

    Values: {
        Value: number;
        Area: number;
    }[];

}

export interface ICroppingReqUpdateModel {
    CroppingId: number;
    CroppingUpdates: { [key: string]: any };
    Zones: IReqZoneUpdateModel[];
    SyncSingleWholeFieldZone: boolean;
}

export interface IBalanceUpdateModel {
    N?: number;
    P2O5?: number;
    K2O?: number;
    MgO?: number;
}

export interface IReqZoneUpdateModel {

    NtrReqId: number;

    RequiredN?: number;
    RequiredSO3?: number;
    RequiredP2O5?: number;
    RequiredK2O?: number;
    RequiredMgO?: number;

    Comments: string;

    Balance?: IBalanceUpdateModel;

}

export interface IAppZoneUpdateModel {

    NtrAppId: number;

    PlanId: number;
    AppId: number;
    CroppingId: number;

    ProductRate: number;
    UserDefined: boolean;
}

export interface IPlanUpdateModel {
    plan: INutritionPlan
    resetEdits?: boolean
    recalculate?: boolean
}

export interface INutritionBiomassOptions {

    Rounding?: number;

    Auto: boolean;

    LowRatesForLowValues?: boolean

    MinRate?: INutritionAppRate;
    MaxRate?: INutritionAppRate;


}

export interface INutritionAppRate {
    Nutrient?: number;
    Product?: number;
}


export interface INutritionPlan extends INutritionPlanOrder {

    NutritionPlanId: number

    HoldingId: number
    YearId: number

    Name: string

    ShouldRecalculate?: boolean

    Precision?: boolean

    Biomass?: boolean
    BiomassOptions?: INutritionBiomassOptions

    MergeAppZones?: boolean

    Nitrogen?: boolean
    PK?: boolean

    Cropping: INutritionPlanCropping[]
    Applications: INutritionPlanProductApp[]

    CreatedBy: number
    CreatedOn: Date
    UpdatedOn: Date
    Metadata: ResourceMetadata

    Restricted: boolean

}

export interface INutritionPlanOrder {

    readonly NutritionPlanId: number

    readonly HoldingId: number
    readonly YearId: number

    CalculationOrder?: number

    readonly CreatedOn: Date


}

export interface INutritionPlanCropping extends INtrReqNutrients {

    NutritionCroppingId: number;

    NutritionPlanId: number;

    CroppingId: number;

    BiomassLayerId?: number;
    BiomassNutrientRate?: number;
    BiomassProductRate?: number;

}

export interface INutritionAppQty {

    NutrientPct?: number
    NutrientRate?: number
    ProductRate?: number

    LastInputUsed?: ProductAppInput

    CutOffProductRate?: number
    MinProductRate?: number
    MaxProductRate?: number

}


export interface INutritionPlanCroppingApp {

    CroppingId: number

    NutrientPct?: number
    NutrientRate?: number
    ProductRate?: number

    LastInputUsed?: ProductAppInput

}

export interface INutritionPlanProductApp extends INutritionAppQty {

    // Note: this is not part of the persisted model, and just used
    // locally while editing plans
    _EditId?: number

    NutritionPlanProductAppId: number;

    NutritionPlanId: number;

    FertiliserId: number;
    Fertiliser?: IFertiliserStock;

    ManureId: number;
    Manure?: IManureStock;

    TargetNutrient?: NutrientType;
    ProductAmount?: number;

    AutoComplete?: boolean;

    ApplicationDate?: Date;
    GrowthStage: string;
    Incorporation?: ManureAppMethod;

    ProductUnit?: FertiliserAppUnit;

    ActualDate?: Date;
    ActualRate?: number;
    ActualRateUnit?: FertiliserAppUnit;
    ActualIncorporation?: ManureAppMethod;

    ZoneLevelEdits?: boolean;

    Cropping?: INutritionPlanCroppingApp[];

}

export interface INutritionTemplate {
    NutritionPlanTemplateId?: number;
    UserId: number;
    Name: string;
    Applications: INutritionTemplateApp[];
}

export interface INutritionTemplateApp {
    NutritionPlanTemplateAppId?: number;
    NutritionPlanTemplateId?: number;
    FertiliserProductId: number;
    Rate: number;
    ProductAppInput: ProductAppInput;
    ApplicationDate: Date;
    TargetNutrient: NutrientType;
    GrowthStage?: string;
    Complete?: boolean;

    FertiliserProduct?: IFertiliserProduct;
}

export interface NvzPlanCropping {

    readonly cropping: ICropping
    readonly croppingId: number

    readonly planRequirements: {
        crop: INtrReq,
        zones: INtrReq[]
    }

}

export interface IPlanEditArguments {

    plan: INutritionPlan
    initialCropping: FieldViewModel[]
    defaultToBiomass?: boolean
    openFirstApp?: boolean
    readOnly?: boolean

}

export interface ICroppingGrouping {

    text: string,
    key: string,

    grouping?: <T extends ICroppingGroupItem>(cropping: T[]) => CroppingGroupVm<T>[]

}

export interface ICroppingGroupItem {
    field: IField;
    cropping: ICropping;
    crop: ICrop
    authorized: boolean;
    selected?: boolean;
    uncropped: boolean;
    hasRequirements?: boolean;
    nmaxGroup: INMaxCropGroup;
    area: number
}

export interface Notifications {

    /** Cropping where the current crop does not match that used when last calculating requirements  */
    mismatchedCrops: FieldViewModel[]

}
